module.exports = __webpack_public_path__ + "static/media/natureFeedback.c4816efd.mp3";